<template>
    <Dialog
        v-model:visible="openDialog"
        :closable="false"
        :modal="true"
        id="overlay_panel"
        style="max-width: 450px"
        class="md:min-w-[400px] mx-4"
    >
        <template #header>
            <!-- <MultistepHeader :processState="processState" /> -->
            <div class="font-medium text-gray-600 text-lg mb-2">
                {{ headerTitle }}
            </div>
        </template>
        <div class="min-h-[350px]">
            <!-- Seleccionar opcion -->
            <div v-if="showOptions">
                <MultistepOptions @optionSelected="updateProcessOption" />
            </div>

            <!-- Servicios disponibles para cambio -->
            <div v-if="showReturnServices">
                <MultistepReturnServices
                    :loading="loadingServices"
                    :services="returnServices"
                />
            </div>

            <!-- Servicios disponibles para devolucion -->
            <div v-if="showChangeServices">
                <MultistepChangeServices
                    :loading="loadingServices"
                    :services="changeServices"
                />
            </div>

            <!-- Detalles de la devolucion a procesar -->
            <div v-if="showReturnDetails">
                <MultistepReturnDetails
                    :service="returnService"
                    :origin="origin"
                    :destination="destination"
                />
            </div>

            <!-- Detalles del cambio a procesar -->
            <div v-if="showChangeDetails">
                <MultistepChangeDetails
                    :service="changeService"
                    :origin="origin"
                    :destination="destination"
                />
            </div>
        </div>

        <template #footer>
            <MultistepNavigator
                :processState="processState"
                :disableNext="disableNext"
                :showNext="showNext"
                :showProcess="showProcess"
                :loading="loading"
                @create="handleCreateShipping"
                @goToNext="goToNext"
                @closeDialog="closeDialog"
            />
        </template>
    </Dialog>
</template>

<script>
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import axios from "axios";
// import MultistepHeader from "./MultistepHeader.vue";
import MultistepOptions from "./MultistepOptions.vue";
import MultistepNavigator from "./MultistepNavigator.vue";
import MultistepReturnServices from "./MultistepReturnServices.vue";
import MultistepChangeServices from "./MultistepChangeServices.vue";
import MultistepReturnDetails from "./MultistepReturnDetails.vue";
import MultistepChangeDetails from "./MultistepChangeDetails.vue";

export default {
    name: "ReturnChangeDialog",
    components: {
        Button,
        Icon,
        // MultistepHeader,
        MultistepNavigator,
        MultistepOptions,
        MultistepReturnServices,
        MultistepChangeServices,
        MultistepReturnDetails,
        MultistepChangeDetails,
    },
    props: {
        openDialog: Boolean,
        envio: Object,
    },
    data() {
        return {
            processState: {
                step: 0,
                option: null,
            },
            showProcess: false,

            showOptions: true,
            showNext: true,
            disableNext: true,
            loading: false,

            showReturnServices: false,
            showChangeServices: false,

            changeServices: [],
            returnServices: [],

            changeService: null,
            returnService: null,

            showReturnServices: false,
            showChangeServices: false,
            loadingServices: false,

            showReturnDetails: false,
            showChangeDetails: false,
            headerTitle: "Elegir operación",

            origin: {
                origen_nombre: this.envio.origen_nombre,
                origen_documento: this.envio.origen_documento,
                origen_calle: this.envio.origen_calle,
                origen_altura: this.envio.origen_altura,
                origen_piso: this.envio.origen_piso,
                origen_dpto: this.envio.origen_dpto,
                origen_telefono: this.envio.origen_telefono,
                origen_observacion: this.envio.origen_observacion,
                origen_cp: this.envio.origen_cp,
                origen_email: this.envio.origen_email,
                origen_localidad: this.envio.origen_localidad,
                origen_provincia: this.envio.origen_provincia,
            },

            destination: {
                destino_nombre: this.envio.destino_nombre,
                destino_documento: this.envio.destino_documento,
                destino_telefono: this.envio.destino_telefono,
                destino_email: this.envio.destino_email,
                destino_cp: this.envio.destino_cp,
                destino_calle: this.envio.destino_calle,
                destino_altura: this.envio.destino_altura,
                destino_piso: this.envio.destino_piso,
                destino_dpto: this.envio.destino_dpto,
                destino_localidad: this.envio.destino_localidad,
                destino_provincia: this.envio.destino_provincia,
                destino_observacion: this.envio.destino_observacion,
            },

            isServerError: false,
            isNotFoundError: false,
        };
    },
    computed: {
        productos() {
            return this.envio.productos.map((p) => ({
                id: p.id,
                alto: p.alto,
                ancho: p.ancho,
                largo: p.largo,
                peso: p.peso_real,
                cantidad: p.cantidad,
                descripcion: p.descripcion,
                precio: p.precio,
            }));
        },
    },
    methods: {
        closeDialog() {
            this.processState = {
                step: 0,
                option: null,
            };
            this.changeService = null;
            this.returnService = null;
            this.showReturnServices = false;
            this.showChangeServices = false;
            this.loadingServices = false;
            this.showReturnDetails = false;
            this.showChangeDetails = false;
            this.showOptions = true;
            this.disableNext = true;
            this.headerTitle = "Elegir operación";
            this.showProcess = false;
            this.showNext = true;
            this.changeServices = [];
            this.returnServices = [];
            this.loading = false;
            this.$emit("closeDialog");
        },
        goToNext() {
            if (this.returnService || this.changeService) {
                this.showNext = false;
                this.showProcess = true;
                this.processState.step = 2;
                if (this.processState.option === "cambio") {
                    this.showChangeServices = false;
                    this.showChangeDetails = true;
                    this.headerTitle = "Detalles para cambio";
                } else if (this.processState.option === "devolucion") {
                    this.showReturnServices = false;
                    this.showReturnDetails = true;
                    this.headerTitle = "Detalles para devolución";
                }
            } else if (this.processState.option !== null) {
                this.goToServices();
            }
        },
        updateProcessOption(option) {
            if (option === "cambio") {
                this.processState.option = "cambio";
                this.disableNext = false;
            } else if (option === "devolucion") {
                this.processState.option = "devolucion";
                this.disableNext = false;
            }
        },
        goToServices() {
            this.processState.step = 1;
            this.showOptions = false;
            if (this.processState.option === "cambio") {
                this.showChangeDetails = true;
                this.headerTitle = "Solicitar cambio";
                this.showNext = false;
                this.showProcess = true;
            } else if (this.processState.option === "devolucion") {
                this.showReturnDetails = true;
                this.headerTitle = "Servicios disponibles para devolución";
                this.showNext = false;
                this.showProcess = true;
            }
        },
        // sleep(ms) {
        //     return new Promise((resolve) => setTimeout(resolve, ms));
        // },
        getReturnServices() {
            this.loadingServices = true;
            // this.sleep(2000).then(() => {
            //     this.returnServices = "Servicios de devolucion - respuesta";
            //     this.loadingServicios = false;
            // });
            axios
                .post("/envios/consultar-servicios-devolucion", {
                    sucursal_id: this.envio.sucursal_id,
                    ...this.origin,
                    ...this.destination,
                    paquetes: this.productos,
                })
                .then((res) => {
                    if (res.status === 200 && res.data.success) {
                        this.loadingServices = false;
                        this.returnServices = res.data.servicios;
                    }
                })
                .catch((err) => {
                    if (err.response.status === 500) {
                        this.isServerError = true;
                    } else if (err.response.status === 404) {
                        this.isNotFoundError = true;
                    }
                    this.loadingServices = false;
                });
        },
        updateReturnService(serviceId) {
            this.returnService = serviceId;
            this.disableNext = false;
        },
        handleCreateShipping() {
            if (this.processState.option === "cambio") {
                this.createChangeShipment();
                // this.closeDialog();
            } else if (this.processState.option === "devolucion") {
                this.createReturnShipment();
                // this.closeDialog();
            }
        },
        createChangeShipment() {
            this.loading = true;
            axios
                .post("/envios/crear-cambio", {
                    sucursal_id: this.envio.sucursal_id,
                    seguimiento: this.envio.seguimiento
                })
                .then((res) => {
                    if (res.data.success) {
                        this.$emit("on-successful-change", res.data.message);
                        this.closeDialog();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    // if (err.request.status === 500) {
                    //     this.$emit("on-display-errors", 'Error de servidor');
                    // }
                    console.log(err.message);
                    // this.closeDialog();
                });
        },
        createReturnShipment() {
            this.loading = true;
            axios
                .post("/envios/crear-devolucion", {
                    sucursal_id: this.envio.sucursal_id,
                    seguimiento: this.envio.seguimiento
                })
                .then((res) => {
                    if (res.data.success) {
                        this.$emit("on-successful-change", res.data.message);
                        this.closeDialog();
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    // if (err.request.status === 500) {
                    //     this.$emit("on-display-errors", 'Error de servidor');
                    // }
                    console.log(err.message);
                    // this.closeDialog();
                });
        },
    },
};
</script>
